import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiMembersKaizenIdeasShowType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = async ({
  id,
}: RequestDataType): Promise<ApiMembersKaizenIdeasShowType> => {
  const response = await new ApiClient().get<ApiMembersKaizenIdeasShowType>(
    `/api/members/kaizen_ideas/${id}`,
  );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersKaizenIdeasShow = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiMembersKaizenIdeasShowType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersKaizenIdeasShow", id],
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
